"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var xstate_1 = require("xstate");
var isArray_1 = __importDefault(require("lodash/isArray"));
var every_1 = __importDefault(require("lodash/every"));
var shuffle_1 = __importDefault(require("lodash/shuffle"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var loadQuestion = function (event) {
    var question = event.currentQuestion;
    var shuffledChoices = question.correct
        ? (0, shuffle_1["default"])(question.choices)
        : question.choices;
    return __assign(__assign({}, question), { choices: shuffledChoices });
};
var quizMachine = (0, xstate_1.createMachine)({
    id: 'quizMachine',
    initial: 'initializing',
    states: {
        initializing: {
            on: {
                LOAD_QUESTION: {
                    actions: [
                        (0, xstate_1.assign)({
                            currentQuestion: function (_, event) { return loadQuestion(event); },
                            currentQuestionKey: function (_, event) { return event.currentQuestionKey; }
                        }),
                    ],
                    target: 'unanswered'
                }
            }
        },
        unanswered: {
            on: {
                ANSWER: {
                    actions: (0, xstate_1.assign)({
                        answer: function (_, event) {
                            return event.answer;
                        }
                    }),
                    target: 'answering'
                },
                LOAD_QUESTION: {
                    actions: [
                        (0, xstate_1.assign)({
                            currentQuestion: function (_, event) { return loadQuestion(event); }
                        }),
                    ],
                    target: 'unanswered'
                }
            }
        },
        answering: {
            invoke: {
                id: 'submitAnswer',
                src: 'submitAnswer',
                onDone: [
                    {
                        target: 'answered',
                        cond: function (context) { return (0, isEmpty_1["default"])(context.currentQuestion.correct); }
                    },
                    { target: 'answered.correct', cond: 'answeredCorrectly' },
                    { target: 'answered.incorrect' },
                ],
                onError: { target: 'failure' }
            }
        },
        answered: {
            type: 'compound',
            initial: 'neutral',
            states: {
                correct: {},
                incorrect: {},
                neutral: {}
            }
        },
        failure: {}
    }
}, {
    guards: {
        answeredCorrectly: function (context, event) {
            var hasMultipleCorrectAnswers = (0, isArray_1["default"])(context.currentQuestion.correct);
            var allCorrect = (0, isArray_1["default"])(context.answer) &&
                (0, every_1["default"])(context.answer.map(function (a) { var _a; return (_a = context.currentQuestion.correct) === null || _a === void 0 ? void 0 : _a.includes(a); }));
            return hasMultipleCorrectAnswers
                ? allCorrect
                : context.currentQuestion.correct === context.answer;
        }
    },
    services: {
        submitAnswer: function (context) { return context.handleSubmitAnswer(context); }
    }
});
exports["default"] = quizMachine;
